(function(){
  if (window.__axOffers) return;
  window.__axOffers = 1;

  var FALLBACK = [];

  /* codes come from the "ZAKDOR offers" section in the theme editor */
  var CACHE = null;
  function offers(){
    if (CACHE) return CACHE;
    try {
      var el = document.getElementById('axOffersData');
      if (el) {
        var d = JSON.parse(el.textContent || '{}');
        var a = [];
        for (var i=0;i<(d.items||[]).length;i++){ if (d.items[i] && d.items[i].code) a.push(d.items[i]); }
        if (a.length) { CACHE = a; return CACHE; }
      }
    } catch(e){}
    CACHE = FALLBACK;
    return CACHE;
  }
  function low(s){ return (s || '').toString().toLowerCase(); }

  var CSS = '.ax-ov{position:fixed;inset:0;z-index:2147483003;background:rgba(4,10,22,.74);display:grid;place-items:center;padding:20px;opacity:0;visibility:hidden;transition:opacity .28s ease,visibility .28s ease}'
  + '.ax-ov.on{opacity:1;visibility:visible}'
  + '.ax-ovc{position:relative;background:linear-gradient(152deg,#102449 0%,#0A1730 100%);border:1px solid rgba(150,178,232,.24);border-radius:20px;max-width:520px;width:100%;padding:34px 30px 28px;box-shadow:0 30px 70px rgba(0,0,0,.55);transform:translateY(16px) scale(.98);transition:transform .38s cubic-bezier(.16,1,.3,1);max-height:86vh;overflow:auto}'
  + '.ax-ov.on .ax-ovc{transform:none}'
  + '.ax-ovx{position:absolute;top:14px;right:14px;width:34px;height:34px;border:0;border-radius:50%;background:rgba(255,255,255,.1);color:#fff;font-size:1.1rem;line-height:1;cursor:pointer;display:grid;place-items:center;transition:background .2s}'
  + '.ax-ovx:hover{background:rgba(255,255,255,.22)}'
  + '.ax-ovh{font-size:1.3rem;font-weight:800;color:#fff;margin:0 0 6px;letter-spacing:.01em}'
  + '.ax-ovs{font-size:.85rem;color:#A6B6D1;margin:0 0 22px;line-height:1.6}'
  + '.ax-offr{border:1px dashed rgba(160,186,236,.42);border-radius:13px;padding:15px 16px;margin-bottom:11px;display:flex;align-items:center;gap:14px;justify-content:space-between;flex-wrap:wrap}'
  + '.ax-offr .tx{min-width:0;flex:1}'
  + '.ax-offr b{display:block;color:#fff;font-size:.95rem;font-weight:700;margin-bottom:3px;line-height:1.35}'
  + '.ax-offr small{color:#A6B6D1;font-size:.78rem}'
  + '.ax-offr .cd{display:inline-block;margin-top:8px;color:#E9EDF3;font-size:.82rem;font-weight:800;letter-spacing:.14em;background:rgba(255,255,255,.07);border-radius:6px;padding:5px 11px}'
  + '.ax-cp{background:#E2E8F1;color:#0A1730;border:0;border-radius:30px;padding:11px 20px;font-family:inherit;font-weight:800;font-size:.72rem;letter-spacing:.09em;cursor:pointer;white-space:nowrap;transition:background .2s,transform .2s}'
  + '.ax-cp:hover{background:#fff;transform:translateY(-1px)}'
  + '.ax-ovf{margin-top:16px;font-size:.75rem;color:#7E8FAD;line-height:1.7}'
  + '@media(max-width:520px){.ax-ovc{padding:28px 20px 22px}.ax-offr{gap:10px}.ax-cp{width:100%}}';

  var ov = null, cssDone = false;

  function styles(){
    if (cssDone) return;
    cssDone = true;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function build(){
    styles();
    ov = document.createElement('div');
    ov.className = 'ax-ov';
    ov.setAttribute('role','dialog');
    ov.setAttribute('aria-modal','true');
    ov.setAttribute('aria-label','Current offers');

    var r = '', L = offers();
    for (var i=0;i<L.length;i++){
      var o = L[i];
      r += '<div class="ax-offr"><div class="tx"><b>' + (o.title || o.code) + '</b><small>' + (o.note || '') +
           '</small><span class="cd">' + o.code + '</span></div>' +
           '<button class="ax-cp" type="button" data-code="' + o.code + '">COPY CODE</button></div>';
    }

    ov.innerHTML = '<div class="ax-ovc">' +
      '<button class="ax-ovx" type="button" aria-label="Close">&#10005;</button>' +
      '<h3 class="ax-ovh">Offers running right now</h3>' +
      '<p class="ax-ovs">Copy a code and paste it in the discount box in your cart or at checkout. One code per order.</p>' +
      r +
      '<p class="ax-ovf">Codes cannot be combined. Discount applies to product value only, not shipping.</p>' +
      '</div>';

    document.body.appendChild(ov);

    ov.addEventListener('click', function(e){
      if (e.target === ov || (e.target.closest && e.target.closest('.ax-ovx'))) { close(); return; }
      var b = e.target.closest ? e.target.closest('.ax-cp') : null;
      if (b) copy(b, 'COPY CODE');
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && ov && ov.classList.contains('on')) close();
    });
  }

  function writeClip(code, done){
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function(){ legacy(code, done); });
    } else { legacy(code, done); }
  }
  function legacy(code, done){
    try {
      var t = document.createElement('textarea');
      t.value = code;
      t.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(t);
      t.select();
      document.execCommand('copy');
      t.remove();
      done();
    } catch(e){ done(); }
  }
  function copy(btn, label){
    var code = btn.getAttribute('data-code');
    writeClip(code, function(){
      btn.textContent = 'COPIED';
      setTimeout(function(){ btn.textContent = label; }, 1800);
    });
  }

  function open(){
    if (!ov) build();
    ov.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    if (!ov) return;
    ov.classList.remove('on');
    document.body.style.overflow = '';
  }
  window.axShowOffers = open;

  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('[data-ax-offers]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);
})();

/* ---- cart coupon box: keeps the theme's own discount field styled to match
   the store, opens it by default so nobody has to hunt for a plus icon, and
   keeps the retired COD-form offer strip out of the cart. ---- */
(function(){
  if (window.__axCoupon) return;
  window.__axCoupon = 1;

  var CSS = '.cart-discount__input,input#cart-discount{background:#FFFFFF!important;background-color:#FFFFFF!important;color:#0A1730!important;border:1.5px solid #CBD5E1!important;border-radius:10px!important;padding:10px 14px!important;font-size:0.9rem!important;font-weight:600!important;height:44px!important;box-shadow:inset 0 1px 2px rgba(0,0,0,0.04)!important}'
    + '.cart-discount__input::placeholder,input#cart-discount::placeholder{color:#94A3B8!important;opacity:1!important;font-weight:500!important}'
    + '.cart-discount__input:focus,input#cart-discount:focus{border-color:#8B5CF6!important;box-shadow:0 0 0 3px rgba(139,92,246,0.18)!important;outline:none!important}'
    + '.cart-discount__button,button.cart-discount__button{background:linear-gradient(135deg,rgba(124,58,237,.88) 0%,rgba(109,40,217,.85) 100%)!important;color:#FFFFFF!important;border:1px solid rgba(167,139,250,.45)!important;border-radius:10px!important;font-weight:800!important;font-size:0.82rem!important;letter-spacing:0.06em!important;text-transform:uppercase!important;height:44px!important;padding:0 20px!important;cursor:pointer!important;transition:all 0.2s ease!important;box-shadow:0 2px 10px rgba(124,58,237,.25)!important}'
    + '.cart-discount__button:hover,button.cart-discount__button:hover{background:linear-gradient(135deg,rgba(109,40,217,.95) 0%,rgba(91,33,182,.90) 100%)!important;transform:translateY(-1px)!important;box-shadow:0 4px 16px rgba(124,58,237,.38)!important}'
    + '.cart-discount__pill{background:#F5F3FF!important;color:#7C3AED!important;border:1px solid #DDD6FE!important;border-radius:6px!important}'
    + '#shopify-section-cart-section .axcod,#cart-drawer .axcod{display:none!important}';

  var cssDone = false;
  function styles(){
    if (cssDone) return;
    cssDone = true;
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function roots(){
    var out = [];
    var p = document.getElementById('shopify-section-cart-section');
    if (p) out.push(p);
    var d = document.getElementById('cart-drawer');
    if (d) out.push(d);
    return out;
  }

  function openBox(root){
    var boxes = root.querySelectorAll('.cart-discount details');
    for (var i = 0; i < boxes.length; i++) {
      var d = boxes[i];
      if (d.getAttribute('data-axopen')) continue;
      d.setAttribute('data-axopen', '1');
      if (!d.open) d.open = true;
    }
  }

  var tick = null, mo = null;
  function run(){
    styles();
    if (mo) mo.disconnect();
    var r = roots();
    for (var i = 0; i < r.length; i++) openBox(r[i]);
    if (mo) {
      for (var j = 0; j < r.length; j++) mo.observe(r[j], { childList: true, subtree: true });
    }
  }
  function schedule(){
    clearTimeout(tick);
    tick = setTimeout(run, 220);
  }
  /* The pay-online codes belong to paying online. Typed into this box they
     would come off a Cash on Delivery order too, so they are turned away
     here with the theme's own "invalid code" line, before the theme asks
     Shopify anything. On window, not document: the theme hears every submit
     on the document first, and this has to come before it. */
  window.addEventListener('submit', function(e){
    var f = e.target, box = f && f.closest ? f.closest('cart-discount-component') : null;
    var input = box ? f.querySelector('input[name="discount"]') : null;
    if (!input || !/^\s*PREPAID/i.test(input.value)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    input.value = '';
    var err = box.querySelector('[ref="cartDiscountError"]'), line = box.querySelector('[ref="cartDiscountErrorDiscountCode"]');
    if (err) err.classList.remove('hidden');
    if (line) line.classList.remove('hidden');
  }, true);

  function boot(){
    if (window.MutationObserver) mo = new MutationObserver(schedule);
    run();
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:cart:discount-update', schedule);
    document.addEventListener('shopify:cart:lines-update', schedule);
    document.addEventListener('theme-drawer:open', schedule);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ---- one source of truth for offers. Every code and every offer line on the
   site is filled in from the ZAKDOR offers section in the theme editor, so a
   code is only ever typed in one place. Hooks:
     data-ax-code="N"    -> that offer's code
     data-ax-title="N"   -> the long wording
     data-ax-short="N"   -> the short band wording (falls back to the title)
     data-ax-note="N"    -> the small print
     data-ax-tpl="N"     -> a sentence containing {code} {title} {short} {note}
     data-ax-offer="N"   -> hidden when offer N no longer exists
     data-ax-heading     -> the card heading
   The announcement bar has no markup of its own, so {code0} {title1} style
   tokens typed into its text are substituted here too. ---- */
(function(){
  if (window.__axSync) return;
  window.__axSync = 1;

  var DATA = null;
  function data(){
    if (DATA) return DATA;
    var out = { heading: 'Offers for you', items: [] };
    var el = document.getElementById('axOffersData');
    if (el) {
      try {
        var p = JSON.parse(el.textContent || '{}');
        if (p) {
          if (p.heading) out.heading = p.heading;
          if (p.items && p.items.length) out.items = p.items;
        }
      } catch (e) {}
    }
    DATA = out;
    return out;
  }

  function val(o, key){
    if (!o) return '';
    if (key === 'code') return o.code || '';
    if (key === 'title') return o.title || o.code || '';
    if (key === 'short') return o.short || o.title || o.code || '';
    if (key === 'note') return o.note || '';
    return '';
  }

  var KEYS = ['code', 'title', 'short', 'note'];
  var RE = /\{(code|title|short|note)([0-9])\}/gi;

  function tokens(root, items){
    if (!document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.indexOf('{') < 0) continue;
      var out = v.replace(RE, function(m, key, i){
        var o = items[parseInt(i, 10)] || items[0];
        return o ? val(o, key.toLowerCase()) : '';
      });
      if (out !== v) n.nodeValue = out;
    }
  }

  function fill(){
    var d = data(), items = d.items, i, n, idx;

    for (var k = 0; k < KEYS.length; k++) {
      var nodes = document.querySelectorAll('[data-ax-' + KEYS[k] + ']');
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        idx = parseInt(n.getAttribute('data-ax-' + KEYS[k]), 10);
        if (isNaN(idx)) continue;
        var t = val(items[idx], KEYS[k]);
        if (n.textContent !== t) n.textContent = t;
      }
    }

    var tpl = document.querySelectorAll('[data-ax-tpl]');
    for (i = 0; i < tpl.length; i++) {
      n = tpl[i];
      idx = parseInt(n.getAttribute('data-ax-tpl'), 10);
      if (isNaN(idx)) continue;
      var src = n.getAttribute('data-ax-src');
      if (src === null) { src = n.innerHTML; n.setAttribute('data-ax-src', src); }
      var o = items[idx];
      var html = src
        .replace(/\{code\}/g, val(o, 'code'))
        .replace(/\{title\}/g, val(o, 'title'))
        .replace(/\{short\}/g, val(o, 'short'))
        .replace(/\{note\}/g, val(o, 'note'));
      if (n.innerHTML !== html) n.innerHTML = html;
    }

    var box = document.querySelectorAll('[data-ax-offer]');
    for (i = 0; i < box.length; i++) {
      idx = parseInt(box[i].getAttribute('data-ax-offer'), 10);
      var gone = isNaN(idx) || !items[idx] || !items[idx].code;
      box[i].style.display = gone ? 'none' : '';
    }

    var hd = document.querySelectorAll('[data-ax-heading]');
    for (i = 0; i < hd.length; i++) {
      if (hd[i].textContent !== d.heading) hd[i].textContent = d.heading;
    }

    var ann = document.getElementById('header-group')
      || document.querySelector('[id*="header_announcements"]')
      || document.getElementById('shopify-section-header_announcements_9jGBFp');
    if (ann) tokens(ann, items);
  }

  function boot(){
    fill();
    setTimeout(fill, 300);
    setTimeout(fill, 1200);
    setTimeout(fill, 3000);
    window.addEventListener('load', fill);
    document.addEventListener('shopify:section:load', function(){ DATA = null; setTimeout(fill, 60); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
